/** QR-code field name prefixing a single-use coupon redemption code (full format: HYUAR=<code>). */
export const HYUAR_REDEMPTION_CODE_PREFIX = "HYUAR";

/** Possible outcomes of a coupon code scan — centralises all scan-state comparisons. */
export enum CouponScanState {
  OK = "OK",
  WrongCode = "WrongCode",
  NotAvailable = "NotAvailable",
}

/** Result of a coupon redemption attempt */
export enum RedemptionResult {
  Proceed = "Proceed",
  AlreadyRedeemed = "AlreadyRedeemed",
  AlreadyInCart = "AlreadyInCart",
  LoginRequired = "LoginRequired",
  NotAvailable = "NotAvailable",
  WrongCode = "WrongCode",
  UnsupportedOrderMode = "UnsupportedOrderMode",
  InvalidCode = "InvalidCode",
}
